/**
 * i18n.js — Configuración de i18next para StarTip
 *
 * REGLAS DE PROTECCIÓN DE MARCA:
 *  • "STARTIP" nunca es una clave de traducción. Está hardcoded en el JSX.
 *  • Los nombres de modelos vienen de la API, nunca del diccionario.
 *  • Idiomas soportados: europeos únicamente.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "./translations";

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: "es",
    fallbackLng: "es",
    load: "languageOnly",
    supportedLngs: ["es", "en", "fr", "de", "it", "pt", "nl", "pl", "ro"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
